import type { EntryPoint } from '#packages/apilib';
import { EditorAPIKey, BiApiKey } from '#packages/apis';
import { createClipboardApi } from './clipboardWrapper';
import { ClipboardApiKey } from './publicApiKey';

export const ClipboardEntrypoint: EntryPoint = {
  name: 'ClipboardApi',
  declareAPIs: () => [ClipboardApiKey],
  getDependencyAPIs: () => [EditorAPIKey, BiApiKey],
  attach(shell) {
    shell.contributeAPI(ClipboardApiKey, () => createClipboardApi(shell));
  },
};
